// extracted by mini-css-extract-plugin
export default {"emailNotification":"SignUpForm-module__emailNotification___WESEt","checkbox":"SignUpForm-module__checkbox___MBzMc"};